import { de as layoutsAdditionalFeatures } from 'Components/ContractGenerator/layouts/AdditionalFeatures';
import { de as layoutsCard } from 'Components/ContractGenerator/layouts/Card';
import { de as layoutsComparisonTable } from 'Components/ContractGenerator/layouts/ComparisonTable';
import { de as layoutsFooter } from 'Components/ContractGenerator/layouts/Footer';
import { de as layoutsFooterButtonStep2 } from 'Components/ContractGenerator/layouts/Footer/ButtonStep2';
import { de as layoutsPriceSummary } from 'Components/ContractGenerator/layouts/PriceSummary';
import { de as layoutsShare } from 'Components/ContractGenerator/layouts/Share';
import { de as layoutsShareModalsCopyLink } from 'Components/ContractGenerator/layouts/Share/Modals/CopyLink';
import { de as layoutsShareModalsCreateLink } from 'Components/ContractGenerator/layouts/Share/Modals/CreateLink';
import { de as layoutsShareModalsCreateLinkLinkSettings } from 'Components/ContractGenerator/layouts/Share/Modals/CreateLink/LinkSettings';
import { de as layoutsShareModalsCreateLinkLinkSettingsType } from 'Components/ContractGenerator/layouts/Share/Modals/CreateLink/LinkSettings/Setting/Type';
import { de as layoutsShareModalsCreateLinkLinkSettingsValue } from 'Components/ContractGenerator/layouts/Share/Modals/CreateLink/LinkSettings/Setting/Value';
import { de as login } from 'Components/ContractGenerator/pages/Login';
import { de as step1Header } from 'Components/ContractGenerator/pages/Step1/Header';
import { de as step1Area } from 'Components/ContractGenerator/pages/Step1/Products/Area';
import { de as step1Product } from 'Components/ContractGenerator/pages/Step1/Products/Product';
import { de as step1SettingsArea } from 'Components/ContractGenerator/pages/Step1/SettingsArea';
import { de as step1SettingsAreaAccommodationType } from 'Components/ContractGenerator/pages/Step1/SettingsArea/AccommodationType';
import { de as step2ContractData } from 'Components/ContractGenerator/pages/Step2/ContractData';
import { de as step2ContractDataForm } from 'Components/ContractGenerator/pages/Step2/ContractData/Form';
import { de as step2Extensions } from 'Components/ContractGenerator/pages/Step2/Extensions';
import { de as step2PaymentType } from 'Components/ContractGenerator/pages/Step2/PaymentType';
import { de as step2Selection } from 'Components/ContractGenerator/pages/Step2/Selection';
import { de as step3Selection } from 'Components/ContractGenerator/pages/Step3/Selection';
import { de as step3Summary } from 'Components/ContractGenerator/pages/Step3/Summary';
import { de as step4 } from 'Components/ContractGenerator/pages/Step4';
import { de as step5 } from 'Components/ContractGenerator/pages/Step5';

const app = {
	userActions: {
		backToStart: 'Zurück zum Start',
		toSummary: 'Zur Zusammenfassung',
		summary: 'Zusammenfassung',
		toBooking: 'Zur Buchung',
		submit: 'Zahlungspflichtig buchen',
		next: 'Weiter',
		back: 'Zurück',
		choose: 'Wählen',
		delete: 'Entfernen',
		inquire: 'Anfragen',
		change: 'Ändern',
		close: 'Schließen',
		cancel: 'Abbrechen'
	},
	userFeedback: {
		api: {
			error: 'Fehler beim Laden der Produktdaten. Bitte versuchen Sie es später erneut.'
		}
	},
	taxInfo: '*Preise zzgl. USt.',
	yes: 'Ja',
	no: 'Nein',
	captchaRequired: 'Bitte bestätigen Sie, dass Sie kein Roboter sind, um fortfahren zu können.',
	fieldsInvalid: 'Bitte füllen Sie alle Felder korrekt aus.',
	errorMessages: {
		unknown: {
			description: 'Fehler beim Laden der Produktdaten. Bitte versuchen Sie es später erneut.'
		},
		520: {
			title: 'Link existiert nicht',
			description:
				'Sie haben versucht einen zuvor gespeicherten Link des Vertragsgenerators zu öffnen. Der angegebene Link existiert leider nicht mehr.'
		}
	}
};

const de = {
	app,
	layouts: {
		card: layoutsCard,
		additionalFeatures: layoutsAdditionalFeatures,
		footer: {
			...layoutsFooter,
			buttonStep2: layoutsFooterButtonStep2
		},
		priceSummary: layoutsPriceSummary,
		share: {
			...layoutsShare,
			modals: {
				createLink: {
					...layoutsShareModalsCreateLink,
					linkSettings: {
						...layoutsShareModalsCreateLinkLinkSettings,
						setting: {
							type: layoutsShareModalsCreateLinkLinkSettingsType,
							value: layoutsShareModalsCreateLinkLinkSettingsValue
						}
					}
				},
				copyLink: layoutsShareModalsCopyLink
			}
		},
		comparisonTable: layoutsComparisonTable
	},
	pages: {
		step1: {
			header: step1Header,
			settingsArea: { ...step1SettingsArea, accommodationType: step1SettingsAreaAccommodationType },
			products: {
				product: step1Product,
				area: step1Area
			}
		},
		step2: {
			selection: {
				...step2Selection
			},
			extensions: {
				...step2Extensions
			},
			paymentType: {
				...step2PaymentType
			},
			contractData: {
				...step2ContractData,
				form: step2ContractDataForm
			}
		},
		step3: {
			selection: {
				...step3Selection
			},
			summary: {
				...step3Summary
			}
		},
		step4: {
			...step4
		},
		step5: {
			...step5
		},
		login: {
			...login
		}
	}
};

export default de;
